import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';
import { handleErrorAvatar } from 'utils/general';
import { AVATAR_URL } from 'constants/api';
import ModalMutualFollower from 'global/Moderation/Modals/ModalFollow/ModalMutualFollower';
import { effects, selectors } from 'global/Moderation/slice';
import {
  FollowedByNameWrapper,
  FollowingByAvatar,
  FollowingByAvatarItem,
} from './styled';

const { Text, Flex } = Common;

interface FollowedByProps {
  userId: number;
  username: string;
}

function FollowedBy({ userId, username }: FollowedByProps) {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  const { userMutualFollower } = useSelector(selectors);

  useEffect(() => {
    dispatch(
      effects.getMutualFollower({
        userid: userId,
        page: 1,
        limit: 10,
      }),
    );
    // dispatch(
    //   effects.getFollowedBy({
    //     userId,
    //     username,
    //   }),
    // );
  }, []);

  const handleClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    dispatch(
      effects.getMutualFollower({
        userid: userId,
        page: 1,
        limit: 10,
      }),
    );
  };

  const followersData = userMutualFollower[userId]?.data ?? [];
  const totalFollowers = userMutualFollower[userId]?.total_follower || 0;
  const showedAvatar = followersData?.slice(0, 3);

  const followingUsername = useMemo(() => {
    const tempFollowingActivity = [];
    followersData?.forEach((user, index) => {
      const isLast = followersData.length - 1 === index;
      if (index === 0) {
        tempFollowingActivity.push(
          <Text
            color={`${color.black}!important`}
            family="bold"
            style={{ display: 'inline-block' }}
          >
            {user.username}
          </Text>,
        );

        if (!isLast) {
          tempFollowingActivity.push(
            <Text family="bold" style={{ display: 'inline-block' }}>
              ,&nbsp;
            </Text>,
          );
        }
      } else if (index === 1) {
        if (isLast) {
          tempFollowingActivity.push(
            <Text style={{ display: 'inline-block' }}>and&nbsp;</Text>,
          );
        }

        tempFollowingActivity.push(
          <Text
            color={`${color.black}!important`}
            family="bold"
            style={{ display: 'inline-block' }}
          >
            {user.username}
          </Text>,
        );

        if (!isLast) {
          tempFollowingActivity.push(
            <Text family="bold" style={{ display: 'inline-block' }}>
              ,&nbsp;
            </Text>,
          );
        }
      } else if (index === 2) {
        tempFollowingActivity.push(
          <Text style={{ display: 'inline-block' }}>and&nbsp;</Text>,
        );

        if (totalFollowers > 3) {
          tempFollowingActivity.push(
            <Text family="bold" style={{ display: 'inline-block' }}>
              {totalFollowers - 2} others
            </Text>,
          );
        } else {
          tempFollowingActivity.push(
            <Text
              color={`${color.black}!important`}
              family="bold"
              style={{ display: 'inline-block' }}
            >
              {user.username}
            </Text>,
          );
        }
      }
    });
    return tempFollowingActivity;
  }, [followersData]);

  if (totalFollowers === 0) {
    return null;
  }

  return (
    <>
      <Flex
        mt="16px"
        align="center"
        justify="center"
        style={{ cursor: 'pointer' }}
        onClick={handleClick}
      >
        <FollowingByAvatar style={{ flexShrink: 0 }}>
          {showedAvatar?.map(
            (
              { user_avatar: avatar, username: userUsername, userid },
              index,
            ) => {
              const avatarUrl = avatar?.startsWith('http')
                ? avatar
                : `${AVATAR_URL}/${avatar}`;
              return (
                <FollowingByAvatarItem
                  key={userid}
                  style={{ left: index * 11, zIndex: 10 - index }}
                >
                  <Image
                    alt="imageProfile"
                    src={avatarUrl}
                    onError={(e) => handleErrorAvatar(e, userUsername)}
                  />
                </FollowingByAvatarItem>
              );
            },
          )}
        </FollowingByAvatar>
        <FollowedByNameWrapper>
          <Text style={{ display: 'inline' }}>Followed by&nbsp;</Text>
          <Text style={{ display: 'inline' }} color={color.highgray}>
            {followingUsername}
          </Text>
        </FollowedByNameWrapper>
      </Flex>
      <ModalMutualFollower
        userId={userId}
        username={username}
        visible={showModal}
        onCancel={handleCloseModal}
      />
      {/* <ModalFollowedBy /> */}
    </>
  );
}

export default FollowedBy;
